import { PageContainer } from '@if/mui'
import LoanList from '@src/components/LoanList/LoanList'
import { useTranslation } from 'react-i18next'

const LoanListPage = () => {
  const { t } = useTranslation()

  return (
    <PageContainer title={t('loan.title')}>
      <LoanList />
    </PageContainer>
  )
}

export default LoanListPage
